import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ELECTRICITY_SUPPLIER = createActionTypes('FETCH_ELECTRICITY_SUPPLIER');
export const GET_ELECTRICITY_SUPPLIER = createActionTypes('GET_ELECTRICITY_SUPPLIER_MAKE');
export const CREATE_ELECTRICITY_SUPPLIER = createActionTypes('CREATE_ELECTRICITY_SUPPLIER');
export const UPDATE_ELECTRICITY_SUPPLIER = createActionTypes('UPDATE_ELECTRICITY_SUPPLIER');
export const DELETE_ELECTRICITY_SUPPLIER = createActionTypes('DELETE_ELECTRICITY_SUPPLIER');
